



























import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class PasswordFieldWidget extends Vue {

  @Inject() public $validator: any;

  @Prop(String) public title!: string;
  @Prop(String) public inputName!: string;
  @Prop(String) public initialValue!: string;
  @Prop(String) public tooltipMessage!: string;
  @Prop(String) public fieldClasses!: string;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Number) public maxLength!: number;
  @Prop(Boolean) public validateOnInput!: boolean;
  @Prop(Boolean) public validateOnBlur!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;

  private inputModel: string = '';
  private inputId: string = '';
  private maxLengthVal: number = 0;
  private showCapsLockWarning: boolean = false;

  public created() {
    this.inputId = 'input' + uuid();
    if (this.formName) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    this.inputModel = this.initialValue;
    if (this.initialValue) {
      this.$emit('input', this.inputModel);
    }

    if (this.validateOnInput) {
      const matcher = {
        name: this.inputName,
      };
      const field = this.$validator.fields.find(matcher);
      field.update({ events: 'input' });
    }
    if (this.validateOnBlur) {
      const matcher = {
        name: this.inputName,
      };
      const field = this.$validator.fields.find(matcher);
      field.update({ events: 'blur' });
    }
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = this.isRequired;
    }
    if (this.maxLength) {
      validator.max = this.maxLength;
      this.maxLengthVal = this.maxLength + 1;
    }
    return validator;
  }

  public updateInputModel($event: any): void {
    if (this.maxLengthVal && $event.target.value.length > this.maxLengthVal) {
      $event.target.value = $event.target.value.slice(0, this.maxLengthVal);
    }
    this.inputModel = $event.target.value;
    this.$emit('input', this.inputModel.length > 0 ? this.inputModel : null);
  }

  public onKeyPress($event: any): void {
    const pressedKey: string = String.fromCharCode($event.which);
    this.showCapsLockWarning = pressedKey.toUpperCase() === pressedKey
      && pressedKey.toLowerCase() !== pressedKey
      && !$event.shiftKey;
  }
}
